import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import HousingStatusForm from '../components/HousingStatusForm';
import { useCreateHousingStatus } from '../hooks/useHousingStatusMutations';

export default function HousingStatusCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateHousingStatus();
  const handleSubmit = (data: any) => { mutation.mutate(data, { onSuccess: () => navigate('/housing-statuses') }); };

  return (
    <div>
      <PageHeader back title={t('housingStatuses.addTitle')} subtitle={t('housingStatuses.addSubtitle')} />
      <Card><HousingStatusForm onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
